/* =========================================================================
   Jysk Plantesalg – Planteliste
   Selvstændig erstatning for Quotify. Ingen Shopify-cart, ingen checkout.

   Modal: fast top (titel + kontaktfelter), scrollbar redigerbar liste,
   fast momsopdelt total lige over knapperne.

   Momslogik matcher vat-toggle.liquid 1:1:
     - priser gemmes i øre
     - inkl.  = øre / 100
     - ekskl. = Math.round(kr / 1.25 * 100) / 100
     - format = da-DK, 2 decimaler, " kr."
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'plantList';
  var CFG = window.PLANT_LIST_CONFIG || {};
  var VAT_RATE = CFG.vatRate || 1.25;
  var ENDPOINT = CFG.endpoint || '';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var TRASH = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>';

  /* ----------------------------------------------------------------- state */
  function read() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('plant-list:change'));
  }
  function count() { return read().reduce(function (n, i) { return n + i.qty; }, 0); }
  function totalOere() { return read().reduce(function (s, i) { return s + (i.price * i.qty); }, 0); }

  function addItem(item) {
    var items = read();
    var found = null;
    for (var i = 0; i < items.length; i++) { if (items[i].id === item.id) { found = items[i]; break; } }
    if (found) { found.qty += item.qty; } else { items.push(item); }
    write(items);
  }
  function setQty(id, qty) {
    var items = read().map(function (i) { if (i.id === id) i.qty = qty; return i; })
                      .filter(function (i) { return i.qty > 0; });
    write(items);
  }
  function removeItem(id) { write(read().filter(function (i) { return i.id !== id; })); }
  function clearList() { localStorage.removeItem(STORAGE_KEY); document.dispatchEvent(new CustomEvent('plant-list:change')); }
  function qtyOf(id) { var f = read().find(function (i) { return i.id === id; }); return f ? f.qty : 0; }

  /* ------------------------------------------------------------------- vat */
  function vatMode() { return window.vatMode || localStorage.getItem('vatMode') || 'incl'; }
  function inclKr(oere) { return oere / 100; }
  function exclKr(oere) { return Math.round((oere / 100) / VAT_RATE * 100) / 100; }
  function fmt(kr) { return kr.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.'; }
  function displayMoney(oere) { return fmt(vatMode() === 'incl' ? inclKr(oere) : exclKr(oere)); }
  function vatLabel() { return vatMode() === 'incl' ? 'Inkl. moms' : 'Ekskl. moms'; }
  function priceHeaderHtml() { return 'Pris<span class="pl-table__vatnote">' + (vatMode() === 'incl' ? 'inkl. moms' : 'ekskl. moms') + '</span>'; }
  function plantWord(n) { return n === 1 ? 'plante' : 'planter'; }

  function breakdown() {
    var oere = totalOere();
    var incl = Math.round(inclKr(oere) * 100) / 100;
    var excl = Math.round(exclKr(oere) * 100) / 100;
    return { incl: incl, excl: excl, moms: Math.round((incl - excl) * 100) / 100 };
  }

  /* --------------------------------------------------------------- helpers */
  function el(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function applyVat() { if (typeof window.vatApply === 'function') { try { window.vatApply(vatMode()); } catch (e) {} } }

  function stepperHtml(id, qty) {
    return '<div class="quantity buttoned-input">' +
      '<button type="button" class="quantity-down" data-pl-dec="' + id + '" aria-label="Færre">&minus;</button>' +
      '<input class="cart-item__quantity-input" type="number" min="0" value="' + qty + '" data-pl-qty="' + id + '" aria-label="Antal">' +
      '<button type="button" class="quantity-up" data-pl-inc="' + id + '" aria-label="Flere">&plus;</button>' +
    '</div>';
  }

  /* ============================================================== DRAWER == */
  var drawer, overlay, fab;

  function openDrawer() {
    renderDrawer();
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('pl-locked');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (!isModalOpen()) {
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('pl-locked');
    }
  }

  function renderDrawer() {
    var body = el('pl-drawer-body');
    var footer = el('pl-drawer-footer');
    var items = read();

    el('pl-drawer-count').textContent = items.length ? '(' + count() + ')' : '';

    if (!items.length) {
      body.innerHTML = '<div class="pl-empty"><div class="pl-empty__icon">🌿</div>' +
        '<p>Din planteliste er tom.</p></div>';
      footer.style.display = 'none';
      return;
    }
    footer.style.display = '';

    body.innerHTML = items.map(function (i) {
      var variantLine = i.variantTitle
        ? '<div class="cart-item__variant"><span class="cart-item__variant-value">' + esc(i.variantTitle) + '</span></div>' : '';
      var skuLine = i.sku
        ? '<div class="line-item-property"><span class="line-item-property__label">Varenummer:</span> ' +
          '<span class="line-item-property__value">' + esc(i.sku) + '</span></div>' : '';
      var img = i.image
        ? '<a href="' + esc(i.url) + '"><img src="' + esc(i.image) + '" alt="' + esc(i.productTitle) + '" width="90"></a>' : '';

      return '<div class="cart-item">' +
        '<div class="cart-item__column cart-item__image">' + img + '</div>' +
        '<div class="cart-item__not-image">' +
          '<div class="cart-item__column cart-item__description">' +
            '<div class="cart-item__title"><a class="text-current" href="' + esc(i.url) + '">' + esc(i.productTitle) + '</a></div>' +
            '<div class="small-text">' + variantLine + skuLine + '</div>' +
          '</div>' +
          '<div class="cart-item__column cart-item__price">' +
            '<span class="theme-money cart-item__selling-price" data-vat-price="' + i.price + '">' + displayMoney(i.price) + '</span>' +
          '</div>' +
          '<div class="cart-item__column cart-item__quantity">' +
            stepperHtml(i.id, i.qty) +
            '<a class="cart-item__remove small-text underline" data-pl-remove="' + i.id + '">Fjern</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    footer.innerHTML =
      '<div class="pl-totals pl-totals--drawer">' + totalsHtml() + '</div>' +
      '<div class="pl-drawer__cta">' +
        '<button type="button" class="btn btn--primary btn--large btn--wide" data-pl-request>Anmod om pris inkl. fragt</button>' +
      '</div>';

    applyVat();
  }

  function bindDrawer() {
    el('pl-drawer-body').addEventListener('click', function (e) {
      var dec = e.target.closest('[data-pl-dec]');
      var inc = e.target.closest('[data-pl-inc]');
      var rem = e.target.closest('[data-pl-remove]');
      if (dec) { var id = +dec.getAttribute('data-pl-dec'); setQty(id, qtyOf(id) - 1); }
      else if (inc) { var id2 = +inc.getAttribute('data-pl-inc'); setQty(id2, qtyOf(id2) + 1); }
      else if (rem) { removeItem(+rem.getAttribute('data-pl-remove')); }
    });
    el('pl-drawer-body').addEventListener('change', function (e) {
      var q = e.target.closest('[data-pl-qty]');
      if (q) { setQty(+q.getAttribute('data-pl-qty'), Math.max(0, parseInt(q.value, 10) || 0)); }
    });
    el('pl-drawer-footer').addEventListener('click', function (e) {
      if (e.target.closest('[data-pl-request]')) openModal();
    });
    el('pl-drawer-close').addEventListener('click', closeDrawer);
  }

  /* =============================================================== MODAL == */
  var modal;

  function isModalOpen() { return modal && modal.classList.contains('is-open'); }
  function isFormActive() { return el('pl-panel-form').classList.contains('is-active'); }

  function showPanel(which) {
    el('pl-panel-form').classList.toggle('is-active', which === 'form');
    el('pl-panel-success').classList.toggle('is-active', which === 'success');
    el('pl-modal-footer').style.display = (which === 'success') ? 'none' : '';
  }

  function openModal() {
    if (!count()) return;
    closeDrawer();
    el('pl-error-banner').classList.remove('is-visible');
    showPanel('form');
    renderModal();
    var sc = el('pl-modal-scroll'); if (sc) sc.scrollTop = 0;
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.classList.add('pl-locked');
  }
  function closeModal() {
    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('pl-locked');
  }

  function renderModal() {
    if (!count()) { closeModal(); return; }
    var scroller = el('pl-modal-scroll');
    var st = scroller ? scroller.scrollTop : 0;
    el('pl-summary').innerHTML = itemsTableHtml();
    if (scroller) scroller.scrollTop = st;
    el('pl-totals').innerHTML = totalsHtml();
  }

  function itemsTableHtml() {
    var rows = read().map(function (i) {
      var sub = [];
      if (i.variantTitle) sub.push(esc(i.variantTitle));
      if (i.sku) sub.push('Varenummer: ' + esc(i.sku));
      var img = i.image
        ? '<img class="pl-table__img" src="' + esc(i.image) + '" alt="' + esc(i.productTitle) + '">'
        : '<div class="pl-table__img pl-table__img--empty"></div>';
      return '<tr>' +
        '<td class="pl-table__imgcell">' + img + '</td>' +
        '<td class="pl-table__info">' +
          '<div class="pl-prodname heading-font">' + esc(i.productTitle) + '</div>' +
          (sub.length ? '<div class="pl-table__sub">' + sub.join('<br>') + '</div>' : '') +
        '</td>' +
        '<td class="pl-num pl-qtycell">' + stepperHtml(i.id, i.qty) + '</td>' +
        '<td class="pl-num pl-pricecell"><div class="pl-pricecell__inner">' +
          '<span class="pl-lineprice">' + displayMoney(i.price * i.qty) + '</span>' +
          '<button type="button" class="pl-remove" data-pl-remove="' + i.id + '" aria-label="Fjern ' + esc(i.productTitle) + '">' + TRASH + '</button>' +
        '</div></td>' +
      '</tr>';
    }).join('');

    return '<table class="pl-table">' +
      '<thead><tr>' +
        '<th class="pl-th-produkt" colspan="2">Produkt</th>' +
        '<th class="pl-num">Antal</th>' +
        '<th class="pl-num">' + priceHeaderHtml() + '</th>' +
      '</tr></thead>' +
      '<tbody>' + rows + '</tbody>' +
    '</table>';
  }

  function totalsHtml() {
    var mode = vatMode();
    var b = breakdown();
    var n = count();
    var subLabel = 'Subtotal ' + (mode === 'incl' ? 'inkl. moms' : 'ekskl. moms');
    var subVal = mode === 'incl' ? b.incl : b.excl;
    var momsLabel = (mode === 'incl' ? 'Heraf moms' : 'Moms') + ' (25%)';

    return '<div class="pl-totals__rows">' +
      '<div class="pl-totals__row"><span>' + subLabel + '</span><span>' + fmt(subVal) + '</span></div>' +
      '<div class="pl-totals__row"><span>' + momsLabel + '</span><span>' + fmt(b.moms) + '</span></div>' +
      '<div class="pl-totals__row pl-totals__row--grand">' +
        '<span class="pl-totals__label"><span class="pl-totals__total-word">Total</span>' +
          '<span class="pl-totals__sub">' + n + ' ' + plantWord(n) + '</span></span>' +
        '<span class="pl-totals__amountwrap">' +
          '<span class="pl-totals__amount">' + fmt(b.incl) + '</span>' +
          '<span class="pl-totals__note">inkl. moms</span></span>' +
      '</div>' +
    '</div>';
  }

  function bindModalList() {
    var s = el('pl-summary');
    s.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-pl-dec]');
      var inc = e.target.closest('[data-pl-inc]');
      var rem = e.target.closest('[data-pl-remove]');
      if (dec) { var id = +dec.getAttribute('data-pl-dec'); setQty(id, qtyOf(id) - 1); }
      else if (inc) { var id2 = +inc.getAttribute('data-pl-inc'); setQty(id2, qtyOf(id2) + 1); }
      else if (rem) { removeItem(+rem.getAttribute('data-pl-remove')); }
    });
    s.addEventListener('change', function (e) {
      var q = e.target.closest('[data-pl-qty]');
      if (q) { setQty(+q.getAttribute('data-pl-qty'), Math.max(0, parseInt(q.value, 10) || 0)); }
    });
  }

  /* Kontakt-felter: Navn, Telefon, Email (påkrævet) + Besked (valgfri) */
  var FIELDS = [
    { id: 'name', label: 'Navn', req: true },
    { id: 'phone', label: 'Telefon', req: true, type: 'tel' },
    { id: 'email', label: 'Email', req: true, type: 'email' },
    { id: 'address1', label: 'Adresse', req: true },
    { id: 'address2', label: 'Adresse 2', req: false },
    { id: 'zip', label: 'Postnummer', req: true },
    { id: 'city', label: 'By', req: true },
    { id: 'message', label: 'Besked', req: false, textarea: true }
  ];

  function getContact() {
    var c = {};
    FIELDS.forEach(function (f) { var n = el('pl-f-' + f.id); c[f.id] = n ? n.value.trim() : ''; });
    return c;
  }

  function validateForm() {
    var ok = true, firstBad = null;
    FIELDS.forEach(function (f) {
      var wrap = el('pl-field-' + f.id);
      if (!wrap) return;
      var input = el('pl-f-' + f.id);
      var val = input.value.trim();
      var bad = (f.req && !val) || (f.type === 'email' && val && !EMAIL_RE.test(val));
      wrap.classList.toggle('pl-invalid', bad);
      if (bad && !firstBad) firstBad = input;
      if (bad) ok = false;
    });
    if (firstBad) {
      var sc = el('pl-modal-scroll');
      if (sc && sc.scrollTo) sc.scrollTo({ top: 0, behavior: 'smooth' });
      else if (sc) sc.scrollTop = 0;
      setTimeout(function () { firstBad.focus({ preventScroll: true }); }, 350);
    }
    return ok;
  }

  /* ------------------------------------------------------------ SUBMIT ---- */
  function buildPayload() {
    var items = read().map(function (i) {
      return {
        productTitle: i.productTitle,
        variantTitle: i.variantTitle || '',
        sku: i.sku || '',
        qty: i.qty,
        url: i.url,
        handle: i.handle || '',
        image: i.image || '',
        unitInclKr: inclKr(i.price),
        unitExclKr: exclKr(i.price),
        lineInclKr: Math.round(inclKr(i.price) * i.qty * 100) / 100,
        lineExclKr: Math.round(exclKr(i.price) * i.qty * 100) / 100
      };
    });
    var b = breakdown();
    return {
      source: 'jyskplantesalg.dk – planteliste',
      submittedAt: new Date().toISOString(),
      currency: 'DKK',
      vatRate: VAT_RATE,
      displayVatMode: vatMode(),
      recipient: CFG.recipient || 'info@jyskplantesalg.dk',
      contact: getContact(),
      items: items,
      totals: { inclKr: b.incl, exclKr: b.excl, vatKr: b.moms }
    };
  }

  function submit() {
    if (!ENDPOINT) { showError('Endpoint mangler. Sæt PLANT_LIST_CONFIG.endpoint i temaet.'); return; }
    var btn = el('pl-btn-send');
    btn.classList.add('pl-btn-busy');
    btn.textContent = 'Sender…';
    el('pl-error-banner').classList.remove('is-visible');

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildPayload())
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json().catch(function () { return {}; }); })
      .then(function () { showPanel('success'); clearList(); })
      .catch(function (err) {
        showError('Der opstod en fejl under afsendelsen. Prøv igen, eller kontakt info@jyskplantesalg.dk. (' + err.message + ')');
      })
      .finally(function () {
        btn.classList.remove('pl-btn-busy');
        btn.textContent = 'Send din planteliste';
      });
  }

  function showError(msg) {
    var b = el('pl-error-banner');
    b.textContent = msg;
    b.classList.add('is-visible');
  }

  function bindModal() {
    el('pl-modal-close').addEventListener('click', closeModal);
    el('pl-success-close').addEventListener('click', closeModal);
    el('pl-btn-cancel').addEventListener('click', closeModal);
    el('pl-btn-send').addEventListener('click', function () { if (validateForm()) submit(); });
    bindModalList();
  }

  /* =========================================================== ADD BUTTON = */
  function bindAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-plant-list-add]');
      if (!btn) return;
      e.preventDefault();
      var item = buildItemFromButton(btn);
      if (!item) return;
      addItem(item);
      flashButton(btn);
      openDrawer();
    });
  }

  function buildItemFromButton(btn) {
    var productId = btn.getAttribute('data-product-id');
    var dataEl = document.querySelector('script[data-plant-list-product="' + productId + '"]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    if (!variants.length) return null;

    var selectedId = null;
    var form = btn.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) selectedId = idInput.value;
    if (!selectedId) { var m = location.search.match(/[?&]variant=(\d+)/); if (m) selectedId = m[1]; }

    var variant = null;
    if (selectedId) { variant = variants.find(function (v) { return String(v.id) === String(selectedId); }); }
    if (!variant) { variant = variants.find(function (v) { return v.available; }) || variants[0]; }

    var qtyInput = form && form.querySelector('[name="quantity"]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    var url = btn.getAttribute('data-product-url') || '';
    return {
      id: variant.id,
      handle: btn.getAttribute('data-product-handle') || '',
      productTitle: btn.getAttribute('data-product-title') || '',
      variantTitle: (variant.title && variant.title !== 'Default Title') ? variant.title : '',
      sku: variant.sku || '',
      price: variant.price,
      image: variant.image || btn.getAttribute('data-product-image') || '',
      url: url + (variant.id ? (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variant.id : ''),
      qty: qty
    };
  }

  function flashButton(btn) {
    var original = btn.getAttribute('data-original-text');
    if (original === null) { btn.setAttribute('data-original-text', btn.innerHTML); original = btn.innerHTML; }
    btn.innerHTML = 'Tilføjet \u2713';
    clearTimeout(btn._plTimer);
    btn._plTimer = setTimeout(function () { btn.innerHTML = original; }, 1600);
  }

  /* ============================================================ REACTIONS = */
  function onChange() {
    var n = count();
    var fabBadge = el('pl-fab-count');
    if (fabBadge) { fabBadge.textContent = n; fabBadge.classList.toggle('is-visible', n > 0); }
    var badges = document.querySelectorAll('[data-plant-list-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      badges[i].classList.toggle('is-visible', n > 0);
    }
    if (drawer.classList.contains('is-open')) renderDrawer();
    if (isModalOpen() && isFormActive()) renderModal();
  }

  function reRenderOpenViews() {
    if (drawer.classList.contains('is-open')) renderDrawer();
    if (isModalOpen() && isFormActive()) renderModal();
  }

  /* =============================================================== INIT === */
  function init() {
    drawer = el('pl-drawer');
    overlay = el('pl-overlay');
    modal = el('pl-modal');
    fab = el('pl-fab');
    if (!drawer || !modal) return;

    bindDrawer();
    bindModal();
    bindAddButtons();

    overlay.addEventListener('click', function () { if (isModalOpen()) return; closeDrawer(); });
    if (fab) fab.addEventListener('click', openDrawer);

    document.addEventListener('plant-list:change', onChange);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-plant-list-open]')) { e.preventDefault(); openDrawer(); }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('#vat-btn-incl, #vat-btn-excl')) setTimeout(reRenderOpenViews, 0);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (isModalOpen()) closeModal(); else closeDrawer(); }
    });

    onChange();

    window.PlantList = { open: openDrawer, close: closeDrawer, add: addItem, count: count, clear: clearList };
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();